import React, {useEffect, useState} from 'react';

import {useHttpClient} from '../../../../common/hook/http';

import ComingSoon from "../../../../common/component/ComingSoon/ComingSoon";
import Loader from '../../../../common/component/Loader/Loader';

import {Container, Row, Col} from 'react-bootstrap';

import './Parking.scss';

const Parking = () => {
    const {callAPI} = useHttpClient()

    // -----------------------------------------------------------------------------------------------------------------

    const [data, setData] = useState(null)

    useEffect(() => {

        const fetchData = async () => {
            try {
                const responseData = await callAPI(
                    `parameters/parking`
                );

                if (responseData.message) {

                } else {

                    setData(responseData)

                }

            } catch (e) {
                console.error(e);
            }
        }

        fetchData()

    }, []);
    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageParking" className="mb-4 mb-xl-5">
            <Container fluid="lg" as="section">
                <Row>
                    <Col xs={12}>
                        {
                            data || data === '' || data === '<p><br></p>' ? (
                                data === '' || data === '<p><br></p>' ? (
                                    <div className="py-5 my-5"><ComingSoon/></div>
                                ) : (
                                    <div className="pt-4" dangerouslySetInnerHTML={{__html: data}}/>
                                )
                            ) : (
                                <div className="py-5 my-5"><Loader text="در حال دریافت اطلاعات"/></div>
                            )
                        }
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Parking;